import React from 'react';

import './EmptyMessage.scss';

type Props = {
	title?: string;
	message?: string;
	className?: string;
	size?: string;
};

const EmptyMessage = ({
	title,
	message,
	className,
	size = 'md'
}: Props): JSX.Element => {
	return (
		<div
			className={`empty-message empty-message-${size} flex flex-col items-center justify-center py-10 xl:py-4${
				className ? ` ${className}` : ''
			}`}
		>
			<h2
				className={`font-normal text-${
					size === 'sm' ? 'xl' : '2xl'
				} empty-message-title text-white`}
			>
				{title}
			</h2>
			{message && (
				<p
					className={`font-normal text-${
						size === 'sm' ? 'base' : 'lg'
					} empty-message-text mt-3 text-center text-white`}
				>
					{message}
				</p>
			)}
		</div>
	);
};

export default EmptyMessage;
